<p-dialog
  #modifyPrompt
  modal="true"
  [(visible)]="showPrompt"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    {{ 'invoices.invoice-modification.prompt.title' | translate | titlecase }}
  </ng-template>
  {{ 'invoices.invoice-modification.prompt.message1' | translate | ucfirst }}
  &quot;{{ itemName }}&quot; {{ 'invoices.invoice-modification.prompt.message2' | translate }}
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary tall" (click)="cancel()">
      {{ 'invoices.invoice-modification.prompt.cancel-button' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary tall" (click)="showPrompt = false; showModification = true">
      {{ 'invoices.invoice-modification.prompt.modify-button' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>

<p-dialog
  modal="true"
  #modification
  [(visible)]="showModification"
  [closable]="false"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    {{ 'invoices.invoice-modification.title' | translate | titlecase }}
  </ng-template>
  <wl-invoice-summary [invoice]="modifiedInvoice" [isEditable]="false" [relatedModification]="this.addedLineItems > 0"></wl-invoice-summary>
  <div style="font-weight: bold">
    {{ 'invoices.invoice-modification.original-invoice' | translate | ucfirst }}:
    {{ invoice.InvoiceHeader.TotalCost | currency }}
  </div>
  <p-table [showGridlines]="true" [value]="invoice.LineItems" styleClass="mb-27">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 85%">{{ 'common.description' | translate | titlecase }}</th>
        <th style="width: 15%" class="t-ar">{{ 'common.revenue.amount' | translate | titlecase }}</th>
      </tr>
    </ng-template>
    <ng-template let-lineItem pTemplate="body">
      <tr>
        <td>{{ lineItem.Item }}</td>
        <td style="text-align: right !important">{{ lineItem.Amount | currency }}</td>
      </tr>
    </ng-template>
  </p-table>

  <div style="font-weight: bold">
    {{ 'invoices.invoice-modification.eligible-items' | translate | titlecase }}
  </div>
  <p-table [showGridlines]="true" [value]="flatRelatedItems" styleClass="mb-27">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr class="grid-header-green">
        <th style="width: 45%">{{ 'common.description' | translate | titlecase }}</th>
        <th style="width: 7%" class="t-ac">{{ 'invoices.invoice-modification.opt-in' | translate | ucfirst }}</th>
        <th style="width: 10%">{{ 'invoices.invoice-modification.action' | translate | ucfirst }}</th>
        <th style="width: 13%" class="t-ar">{{ 'invoices.invoice-modification.flat-amount' | translate | ucfirst }}</th>
        <th style="width: 5%" class="t-ar">{{ 'invoices.invoice-modification.percentage' | translate | ucfirst }}</th>
        <th style="width: 20%" class="t-ar">{{ 'invoices.invoice-modification.custom-amount' | translate | ucfirst }}</th>
      </tr>
    </ng-template>
    <ng-template let-related pTemplate="body">
      <tr class="grid-row-green">
        <td>{{ related.Descr }}</td>
        <td class="t-ac">
          <p-checkbox [(ngModel)]="related.OptOut" binary="true" (ngModelChange)="optInCheckChanged(related)"></p-checkbox>
        </td>
        <td>{{ related.ActionDisplay }}</td>
        <td class="t-ar">{{ related.FlatAmount | currency }}</td>
        <td class="t-ar">{{ related.PercentOfLineItemAmount | atlasPercent }}</td>
        <td class="t-ar">
          <div class="input-group">
            <wl-currency-symbol class="input-group-addon"></wl-currency-symbol>
            <input
              type="number"
              class="form-control t-ar"
              [ngModel]="related.ComputedAmount"
              (ngModelChange)="customAmountChanged(related, $event)"
            />
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div style="font-weight: bold">
    {{ 'invoices.invoice-modification.proposed-invoice' | translate | ucfirst }}:
    {{ modifiedInvoice.InvoiceHeader.TotalCost | currency }}
  </div>
  <p-table [showGridlines]="true" [value]="modifiedInvoice.LineItems" styleClass="mb-27">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 85%">{{ 'common.description' | translate | titlecase }}</th>
        <th style="width: 15%; text-align: right !important">{{ 'common.revenue.amount' | translate | titlecase }}</th>
      </tr>
    </ng-template>
    <ng-template let-lineItem pTemplate="body">
      <tr [ngClass]="lineItem._isRelatedRevenueItem ? 'grid-row-green' : ''">
        <td>{{ lineItem.Item }}</td>
        <td style="text-align: right !important">
          {{ lineItem.Amount + lineItem.AdjustmentAmountToApply | currency }}
        </td>
      </tr>
    </ng-template>
  </p-table>

  <ng-template pTemplate="footer">
    <button pButton (click)="cancel()" icon="pi pi-ban" class="atlas-btn atlas-btn-secondary" [disabled]="isSaving">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton (click)="saveModifications()" class="atlas-btn atlas-btn-primary" [disabled]="isSaving">
      @if (isSaving) {
        <i class="pi pi-spinner mr-5"></i>
        {{ 'common.saving' | translate | uppercase }}
      } @else {
        <i class="pi pi-save mr-5"></i>
        {{ 'common.save' | translate | uppercase }}
      }
    </button>
  </ng-template>
</p-dialog>
